import { apiChat } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetMessages = (contactId: string | null) => {
  return useQuery({
    queryKey: ['chats', contactId],
    queryFn: contactId
      ? () => apiChat.chat.getChatMessagesByContactId({ contactId })
      : undefined,
    enabled: !!contactId
  });
};
export default useGetMessages;
